import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, Grid, Typography } from '@mui/material';
import { MAIN_THEME_COLOR, WHITE } from '../../assets/theme/Colors';

import Resident360Dashboard from './Resident360Dashboard';
import SystemUsageDashboard from './SystemUsageDashboard';
import MainGrid from '../../components/MainGrid';
import AlertBanner from '../../components/AlertBanner';
import { useNavigate } from 'react-router-dom';
import { fetch360DashboardData } from '../../services/ElderService';
import { getAccessToken, getElderHomeId } from '../../Utils/AuthUtil';
import IconButton from '../../components/IconButton';

const TABS = {
	system: 'Analytics and resident management',
	resident: 'Resident 360',
};

function Home() {
	const [tab, selectedTab] = useState(TABS.system);
	const navigate = useNavigate();
	const token = getAccessToken();
	const homeId = getElderHomeId();
	const [residentCount, setResidentCount] = useState(null);
	const [showNoResidentBanner, setShowNoResidentBanner] = useState(false);
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		fetchDashboardData();
	}, []);

	async function fetchDashboardData() {
		const response = await fetch360DashboardData(homeId, token);
		if (!response.error) {
			setResidentCount(
				response.totalResident ? response.totalResident : null,
			);
			setShowNoResidentBanner(response.totalResident ? false : true);
		}
	}

	function onRenderHomeContent(params) {
		if (tab === TABS.system) {
			return <SystemUsageDashboard />;
		} else {
			return <Resident360Dashboard />;
		}
	}

	async function onSelect(item) {
		if (tab === item) {
			// Same tab clicked → refresh child
			setRefreshKey(prev => prev + 1);
		} else {
			// Switch tabs
			selectedTab(item);
		}
	}

	return (
		<MainGrid>
			<Grid
				container
				sx={{
					backgroundColor: '#FFFFFF',
					borderRadius: '5px',
					marginLeft: '30px',
					paddingX: '8px',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}>
				<Grid
					width={'80%'}
					flexDirection={'row'}
					columnGap={1}
					padding={'10px'}>
					{Object.values(TABS).map((item, index) => (
						<ButtonBase
							key={index}
							onClick={() => onSelect(item)}
							sx={{
								height: 38,
								backgroundColor:
									item == tab ? '#F9F8F9' : WHITE,
								padding: '5px 24px 5px 24px',
								borderBottom:
									item == tab
										? `2px solid ${MAIN_THEME_COLOR}`
										: '',
							}}>
							<Typography
								fontSize={'14px'}
								fontWeight={'500'}
								color={
									item == tab ? MAIN_THEME_COLOR : '#686868'
								}>
								{item}
							</Typography>
						</ButtonBase>
					))}
				</Grid>
				{residentCount && residentCount !== 0 && (
					<Grid>
						<IconButton
							text={'Onboard Resident'}
							onClick={() => navigate('/addResident')}
						/>
					</Grid>
				)}
			</Grid>
			{showNoResidentBanner && (
				<Grid
					container
					sx={{
						borderRadius: '5px',
						marginLeft: '30px',
						marginTop: '10px',
					}}>
					<AlertBanner
						content={
							'No residents available. Add residents to get started.'
						}
						btnOneTxt={'Manual Onboarding'}
						btnTwoTxt={'Connect Api'}
						handleButtonOneClick={() => navigate('/addResident')}
						handleButtonTwoClick={() => navigate('/integration')}
						displayBtnOne={true}
						displayBtnTwo={true}
					/>
				</Grid>
			)}
			<Grid container key={`${tab}-${refreshKey}`}>
				{onRenderHomeContent()}
			</Grid>
		</MainGrid>
	);
}

export default Home;
